exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.summary_title_description{\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.summary__quantity__unavailable {\n  position: relative;\n  top: 0;\n  margin-top: 0;\n  float: right;\n  padding: 10px;\n  border-radius: 5px;\n  background: #efefef;\n}\n.summary{\n.quantityAndShop {\n  height: 40px;\n}\n} \n\n", ""]);

// exports
